import React, { useMemo } from 'react';
import { ButtonProps } from 'antd/lib/button';
import { CmonJobInstanceCommand } from '../../services/cmon/models/CmonJobInstance';
import CcNode from '../../services/models/CcNode';
import JobCreateActionButton from '../Jobs/JobCreateActionButton';

export default UninstallCmonAgentButton;

export type UninstallCmonAgentButtonProps = ButtonProps & {
    node: CcNode;
    children?: React.ReactNode;
    onSuccess?: () => void;
};

function UninstallCmonAgentButton({
    node,
    children,
    onSuccess,
    ...rest
}: UninstallCmonAgentButtonProps) {
    const jobData = useMemo(
        () => ({
            hostname: node.hostname,
        }),
        []
    );
    return (
        <JobCreateActionButton
            clusterId={node.clusterid}
            command={CmonJobInstanceCommand.UNINSTALL_CMONAGENT}
            confirmTitle={`Uninstall monitoring agent from ${node.getName()}?`}
            title={`Uninstall monitoring agent`}
            jobData={jobData}
            onSuccess={onSuccess}
            extraKey={[node.hostname, node.port]}
            {...rest}
        />
    );
}
